import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownListComponent } from './dropdownlist.component';
/**
 * NgModule definition for the DropDownList component.
 */
export class DropDownListModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DropDownListComponent
    ],
    exports: [
        DropDownListComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownListModule_tsickle_Closure_declarations() {
/** @type {?} */
DropDownListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownListModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
